import {
  Button,
  Field,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLabel,
  Input,
} from "@base/ui";
import { useState, type FormEvent } from "react";
import { Link } from "../../../shared/navegacao/navegacao";
import { useEsqueciSenha } from "../application/use-usuarios";
import { ArrowRight } from "lucide-react";
import {
  BOTAO_DE_ACESSO,
  CAMPO_DE_ACESSO,
  CabecalhoDeAcesso,
  LayoutDeAcesso,
} from "./layout-de-acesso";
import { mensagemDoErro } from "../../../shared/http/mensagem-de-erro";

/**
 * "Esqueci minha senha". A confirmacao e a mesma exista ou nao o e-mail: a
 * tela nao pode servir para descobrir quem tem conta.
 */
export function PaginaEsqueciSenha() {
  const esqueci = useEsqueciSenha();
  const [email, setEmail] = useState("");

  function enviar(evento: FormEvent<HTMLFormElement>) {
    evento.preventDefault();
    esqueci.mutate(email.trim().toLowerCase());
  }

  return (
    <LayoutDeAcesso>
      {esqueci.isSuccess ? (
        <div role="status" className="flex flex-col gap-6">
          <CabecalhoDeAcesso
            rotulo="Recuperar acesso"
            titulo="Confira o seu e-mail"
            descricao={
              <>
                Se <strong className="text-foreground">{email}</strong> estiver cadastrado,
                enviamos um link para criar uma senha nova. Ele vale por 1 hora.
              </>
            }
          />
          <Link para="/entrar" className="text-xs font-bold underline underline-offset-4">
            Voltar para o login
          </Link>
        </div>
      ) : (
        <form className="flex flex-col gap-6" onSubmit={enviar} noValidate>
          <FieldGroup>
            <CabecalhoDeAcesso
              rotulo="Recuperar acesso"
              titulo="Esqueceu a senha?"
              descricao="Informe o seu e-mail e enviaremos um link para criar uma senha nova."
            />
            <Field>
              <FieldLabel htmlFor="email" className="text-xs font-bold">E-mail</FieldLabel>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                placeholder="voce@clinica.com.br"
                value={email}
                onChange={(evento) => setEmail(evento.target.value)}
                className={CAMPO_DE_ACESSO}
                required
              />
            </Field>
            {esqueci.isError ? <FieldError>{mensagemDoErro(esqueci.error)}</FieldError> : null}
            <Field>
              <Button type="submit" className={BOTAO_DE_ACESSO} disabled={esqueci.isPending || !email}>
                {esqueci.isPending ? "Enviando…" : "Enviar link"}
                <ArrowRight aria-hidden="true" />
              </Button>
              <FieldDescription className="text-center text-xs">
                <Link para="/entrar">Voltar para o login</Link>
              </FieldDescription>
            </Field>
          </FieldGroup>
        </form>
      )}
    </LayoutDeAcesso>
  );
}
